import React from 'react'

export function OrderError() {
  return <div></div>
}